import Anchor from 'atoms/Anchor'
import breakpoints from 'config/mediaBreakpoints'
import Button from 'deprecated/atoms/button'
import ErrorMessage from 'deprecated/atoms/errorMessage'
import { History } from 'history'
import InputFormField from 'molecules/inputFormField'
import React, { useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import classNames from 'utils/classNames'
import './loginForm.css'

const Account = require('!babel-loader!svg-react-loader?name=Account!../../../assets/svg/icAccount.svg')

interface LoginForm {
  email?: string
}

interface LoginFormInterface {
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void
  errorMessage?: string | null
  valid: boolean
  onSubmit?: (
    e: React.FormEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>
  ) => void
  form: LoginForm
  history?: History
  submitted?: boolean
  setSubmitted?: any
}

const AboutFanAI = () => (
  <Anchor
    external={true}
    href="https://www.fanai.io/home/"
    style={{ gridColumn: 1 }}
  >
    About FanAI
  </Anchor>
)

export const ErrorComponent = ({ animated = false }) => (
  <ErrorMessage
    animated={animated}
    className="errorMessage"
    message={'Email is incorrect'}
  />
)

export default (props: LoginFormInterface): JSX.Element => {
  const isMobile = useMediaQuery({
    maxWidth: breakpoints.smallerThanLoginCardWidth
  })

  return (
    <>
      <form onSubmit={props.onSubmit} className="loginForm">
        {props.submitted ? (
          <div>
            <h1>Check Your Email!</h1>
            <p>
              We emailed you a link to{' '}
              <span style={{ color: '#013459', fontWeight: 'bold' }}>
                {props.form.email}
              </span>{' '}
              <br />
              Check your email to securely log in. The link will
              <br /> expire in 15 minutes.
            </p>
            <button
              className="backButton"
              onClick={() => props.setSubmitted(false)}
            >
              back
            </button>
          </div>
        ) : (
          <>
            <div>
              <h1>Welcome!</h1>
              <p>Please enter your email below to continue</p>
              {isMobile && props.errorMessage ? (
                <ErrorComponent animated={isMobile} />
              ) : null}
              <InputFormField
                label="email"
                icon={!isMobile && Account}
                valid={!!props.errorMessage}
                inputProps={{
                  autoFocus: true,
                  'data-ref': 'loginFormEmailField',
                  defaultValue: props.form.email || '',
                  id: 'loginEmail',
                  name: 'email',
                  onBlur: props.onBlur,
                  onChange: props.onChange,
                  type: 'text',
                  valid: !props.errorMessage,
                  theme: classNames({
                    'bordered dark': isMobile
                  })
                }}
              />

              {!isMobile ? (
                props.errorMessage ? (
                  <ErrorComponent />
                ) : (
                  <div style={{ height: 11 }} />
                )
              ) : null}
            </div>
            <footer>
              <div className="loginFooterButtonContainer">
                <Button
                  label="Continue"
                  type="submit"
                  onClick={() => {
                    props.onSubmit
                  }}
                  className="primary buttonLogin"
                  data-ref="loginFormSubmitButton"
                />
              </div>
            </footer>
          </>
        )}
      </form>
    </>
  )
}
